export default {
  ASSET_GALLERY: {
    NORMAL: 'NORMAL',
    UPLOAD_PENDING: 'UPLOAD_PENDING',
    UPLOADING: 'UPLOADING',
    SEARCHING: 'SEARCHING',
    EDITTING: 'EDITTING'
  },
  UPLOADER_PANEL: {
    PENDING: 'PENDING',
    UPLOADING: 'UPLOADING',
    COMPLETED: 'COMPLETED'
  },
  ASSET_FILE: {
    UPLOAD_PENDING: 'UPLOAD_PENDING',
    UPLOAD: 'UPLOAD',
    UPLOADING: 'UPLOADING',
    COMPLETED: 'COMPLETED',
    ERROR: 'ERROR'
  }
};



// WEBPACK FOOTER //
// ./src/components/common/AssetGalleryV2/constants/modes.js